"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    messageBarBodyClassNames: function() {
        return messageBarBodyClassNames;
    },
    useMessageBarBodyStyles_unstable: function() {
        return useMessageBarBodyStyles_unstable;
    }
});
const _react = require("@griffel/react");
const messageBarBodyClassNames = {
    root: 'fui-MessageBarBody'
};
const useRootBaseStyles = /*#__PURE__*/ (0, _react.__resetStyles)("rnv3mfe", "r1ixc1x8", [
    ".rnv3mfe{font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);grid-row-start:body;grid-column-start:body;grid-row-end:body;grid-column-end:body;padding-right:var(--spacingHorizontalM);}",
    ".r1ixc1x8{font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase300);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);grid-row-start:body;grid-column-start:body;grid-row-end:body;grid-column-end:body;padding-left:var(--spacingHorizontalM);}"
]);
const useMessageBarBodyStyles_unstable = (state)=>{
    const rootBaseStyles = useRootBaseStyles();
    state.root.className = (0, _react.mergeClasses)(messageBarBodyClassNames.root, rootBaseStyles, state.root.className);
    return state;
}; //# sourceMappingURL=useMessageBarBodyStyles.styles.js.map
